import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmHoanThanh = _resolveComponent("ConfirmHoanThanh")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_PageHeaderActionItem = _resolveComponent("PageHeaderActionItem")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.bienBan)
      ? (_openBlock(), _createBlock(_component_ConfirmHoanThanh, {
          key: 0,
          "bien-ban-data": _ctx.bienBan,
          show: _ctx.showCompleteDialog,
          onClose: _ctx.closeCompleteDialog,
          onConfirm: _ctx.handleComplete
        }, null, 8, ["bien-ban-data", "show", "onClose", "onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.asMenuItem)
      ? (_openBlock(), _createBlock(_component_PageHeaderActionItem, {
          key: 1,
          variant: "success",
          disabled: _ctx.computedIsDisabled,
          onClick: _ctx.openCompleteDialog
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: _ctx.faCalendarCheck }, null, 8, ["icon"])
          ]),
          default: _withCtx(() => [
            _createTextVNode(" " + _toDisplayString(_ctx.computedTooltipMessage || 'Hoàn thành'), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]))
      : (_openBlock(), _createBlock(_component_ButtonCustom, {
          key: 2,
          "button-type": _ctx.ButtonsType.DONE,
          "color-type": _ctx.ButtonTypeColors.PRIMARY,
          "is-disabled": _ctx.computedIsDisabled,
          "tooltip-message": _ctx.computedTooltipMessage,
          classes: _ctx.classes,
          onClick: _ctx.openCompleteDialog
        }, _createSlots({ _: 2 }, [
          (_ctx.showButtonLabel)
            ? {
                name: "button-label",
                fn: _withCtx(() => [
                  _createTextVNode(" Hoàn thành ")
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["button-type", "color-type", "is-disabled", "tooltip-message", "classes", "onClick"]))
  ]))
}